// Generated by purs version 0.15.14
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT);
var lift1 = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Reader_Trans.monadTransReaderT);
var monadRefRefEffect = {
    "new": Effect_Ref["new"],
    read: Effect_Ref.read,
    modify: function (ref) {
        return function (f) {
            return Effect_Ref.modify(f)(ref);
        };
    },
    Monad0: function () {
        return Effect.monadEffect;
    }
};
var monadRefRefAff = {
    "new": function ($35) {
        return liftEffect(Effect_Ref["new"]($35));
    },
    read: function ($36) {
        return liftEffect(Effect_Ref.read($36));
    },
    modify: function (ref) {
        return function (f) {
            return liftEffect(Effect_Ref.modify(f)(ref));
        };
    },
    Monad0: function () {
        return Effect_Aff.monadAff;
    }
};
var read = function (dict) {
    return dict.read;
};
var $$new = function (dict) {
    return dict["new"];
};
var modify = function (dict) {
    return dict.modify;
};
var modify_ = function (dictMonadRef) {
    var $$void = Data_Functor["void"]((((dictMonadRef.Monad0()).Bind1()).Apply0()).Functor0());
    var modify1 = modify(dictMonadRef);
    return function (ref) {
        return function (f) {
            return $$void(modify1(ref)(f));
        };
    };
};
var put = function (dictMonadRef) {
    var modify_1 = modify_(dictMonadRef);
    return function (ref) {
        return function (val) {
            return modify_1(ref)(Data_Function["const"](val));
        };
    };
};
var monadRefExceptT = function (dictMonadRef) {
    var Monad0 = dictMonadRef.Monad0();
    var lift2 = lift(Monad0);
    var modify1 = modify(dictMonadRef);
    var monadExceptT = Control_Monad_Except_Trans.monadExceptT(Monad0);
    return {
        "new": (function () {
            var $37 = $$new(dictMonadRef);
            return function ($38) {
                return lift2($37($38));
            };
        })(),
        read: (function () {
            var $39 = read(dictMonadRef);
            return function ($40) {
                return lift2($39($40));
            };
        })(),
        modify: function (ref) {
            return function (f) {
                return lift2(modify1(ref)(f));
            };
        },
        Monad0: function () {
            return monadExceptT;
        }
    };
};
var monadRefReaderT = function (dictMonadRef) {
    var Monad0 = dictMonadRef.Monad0();
    var lift2 = lift1(Monad0);
    var modify1 = modify(dictMonadRef);
    var monadReaderT = Control_Monad_Reader_Trans.monadReaderT(Monad0);
    return {
        "new": (function () {
            var $41 = $$new(dictMonadRef);
            return function ($42) {
                return lift2($41($42));
            };
        })(),
        read: (function () {
            var $43 = read(dictMonadRef);
            return function ($44) {
                return lift2($43($44));
            };
        })(),
        modify: function (ref) {
            return function (f) {
                return lift2(modify1(ref)(f));
            };
        },
        Monad0: function () {
            return monadReaderT;
        }
    };
};
export {
    $$new as new,
    read,
    modify,
    modify_,
    put,
    monadRefReaderT,
    monadRefExceptT,
    monadRefRefAff,
    monadRefRefEffect
};
